
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Sparkles, Users, Clock, DollarSign } from "lucide-react";

interface AnalysisNavigationProps {
  activeAnalysis: string;
  onAnalysisChange: (value: string) => void;
}

const AnalysisNavigation = ({ activeAnalysis, onAnalysisChange }: AnalysisNavigationProps) => {
  return (
    <div className="flex-shrink-0 mb-2">
      <Card className="bg-secondary/50 backdrop-blur-lg border border-primary/20">
        <CardContent className="p-2">
          <div className="flex gap-1 w-full">
            <Button
              variant={activeAnalysis === "overview" ? "default" : "outline"}
              size="sm"
              onClick={() => onAnalysisChange("overview")}
              className={`px-3 py-1 flex-1 text-xs ${
                activeAnalysis === "overview"
                  ? "bg-primary text-black"
                  : "border-primary/20 bg-secondary/50 text-white hover:bg-gray-800"
              }`}
            >
              Overview
            </Button>
            <Button
              variant={activeAnalysis === "structure" ? "default" : "outline"}
              size="sm"
              onClick={() => onAnalysisChange("structure")}
              className={`px-3 py-1 flex-1 text-xs ${
                activeAnalysis === "structure"
                  ? "bg-primary text-black"
                  : "border-primary/20 bg-secondary/50 text-white hover:bg-gray-800"
              }`}
            >
              Organization Structure
            </Button>
            <Button
              variant={activeAnalysis === "resources" ? "default" : "outline"}
              size="sm"
              onClick={() => onAnalysisChange("resources")}
              className={`px-3 py-1 flex-1 text-xs ${
                activeAnalysis === "resources"
                  ? "bg-primary text-black"
                  : "border-primary/20 bg-secondary/50 text-white hover:bg-gray-800"
              }`}
            >
              Resource Recommendations
            </Button>
            <Button
              variant={activeAnalysis === "allocation" ? "default" : "outline"}
              size="sm"
              onClick={() => onAnalysisChange("allocation")}
              className={`px-3 py-1 flex-1 text-xs ${
                activeAnalysis === "allocation"
                  ? "bg-primary text-black"
                  : "border-primary/20 bg-secondary/50 text-white hover:bg-gray-800"
              }`}
            >
              Task Allocation
            </Button>
            <Button
              variant={activeAnalysis === "budget" ? "default" : "outline"}
              size="sm"
              onClick={() => onAnalysisChange("budget")}
              className={`px-3 py-1 flex-1 text-xs ${
                activeAnalysis === "budget"
                  ? "bg-primary text-black"
                  : "border-primary/20 bg-secondary/50 text-white hover:bg-gray-800"
              }`}
            >
              Budget & Cost Analysis
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AnalysisNavigation;
